var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qr-code" },
    [
      _c("h3", [_c("b", [_vm._v(_vm._s(_vm.$t("presence")))])]),
      _c("qrcode", {
        ref: "qrCode",
        attrs: { value: _vm.url, options: { width: 300 }, tag: "img" }
      }),
      _c(
        "div",
        { staticClass: "q-mb-md" },
        [
          _vm._v("\n        " + _vm._s(_vm.url) + "\n        "),
          _c("q-btn", {
            staticClass: "q-pa-sm q-mx-xs",
            attrs: {
              icon: "far fa-copy",
              "aria-label": _vm.$t("copy_link"),
              title: _vm.$t("copy_link")
            },
            on: { click: _vm.copyToClipboard }
          })
        ],
        1
      ),
      _c("q-btn", {
        staticClass: "q-pa-sm q-mx-xs",
        attrs: { icon: "fas fa-print", label: _vm.$t("print") },
        on: { click: _vm.printQrCode }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }